import React, { useState, useEffect, useRef } from 'react';
import {
  Form,
  Input,
  Button,
  Alert,
  Row,
  Col,
  message,
  Typography,
} from 'antd';
import { ExclamationCircleFilled, InfoCircleOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { requestPasswordReset } from '../../../store/user/actions';
import { types } from '../../../store/user/types';
import { types as formTypes } from '../../../store/forms/types';
import { getLocalString, localNames } from 'utils/localisation.service';
import '../../../styles/pages/_forgotPassword.scss';
import { ReactComponent as ArrowLeft } from '../../../assets/icons/arrow-left.svg';
import { isEmpty } from 'lodash';
import { SuccessModal, InvalidModal } from 'components/layout/components';

const { Paragraph } = Typography;

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [email, setEmail] = useState('');
  const [isVisible, setVisible] = useState(false);
  const [isVisibleError, setVisibleError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const loading = useSelector(state => state.forms.loading);
  const hasError = useSelector(state => state.forms.hasError);
  const initiated = useSelector(state => state.forms.initiated);

  const locales = useSelector(state => state.forms?.localeStrings);

  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [form]);

  useEffect(() => {
    if (initiated && inputRef.current) {
      inputRef.current.focus();
    }
  }, [initiated]);

  useEffect(() => {
    dispatch({ type: types.RESET_USER });
    dispatch({ type: formTypes.RESET_FORM });
    dispatch({ type: formTypes.SET_FORM_INITIATED });
  }, [dispatch]);

  useEffect(() => {
    if (initiated && inputRef.current) {
      inputRef.current.focus();
    }
  }, [initiated]);

  const handleSubmit = async () => {
    try {
      dispatch(
        requestPasswordReset(email, check => {
          if (!check) setVisible(true);
        })
      );
    } catch (error) {
      setErrorMessage(
        'Αποτυχία αποστολής email επαναφοράς κωδικού. Παρακαλώ δοκιμάστε ξανά.'
      );
      setVisibleError(true);
    }
  };

  if (!initiated) return null;

  return (
    <>
      <SuccessModal
        isVisible={isVisible}
        setVisible={setVisible}
        title={'Επιτυχής Υποβολή!'}
        message={
          <>
            <div>
              'Έχουμε αποστείλει οδηγίες στη δηλωμένη διεύθυνση email σας για
              την επαναφορά του κωδικού πρόσβασης.
            </div>
            <div className="mt-2">
              Η παραλαβή του μηνύματος ενδέχεται να χρειαστεί 1 με 2 λεπτά.
            </div>
          </>
        }
        returnButtonTitle={'Επιστροφή στην Αρχική'}
        returnButtonNavigate={'/loginAs'}
      />
      <InvalidModal
        custom={true}
        isVisible={isVisibleError}
        setVisible={setVisibleError}
        error={
          'Αποτυχία αποστολής email επαναφοράς κωδικού. Παρακαλώ δοκιμάστε ξανά.'
        }
        returnButtonTitle={'Επιστροφή στην Αρχική'}
        returnButtonNavigate={'/loginAs'}
      />
      <div className={'main-wrapper change-password-wrapper'}>
        <div className={'change-password-page'}>
          <div className={'change-password-header'}>
            <h2 className={'change-password-title'}>
              Ξεχάσατε τον Κωδικό σας;
            </h2>
          </div>
          <div className="change-password-description">
            Εισάγετε την καταχωρημένη διεύθυνση email σας στην ακόλουθη φόρμα
            και θα σας στείλουμε οδηγίες για την δημιουργία νέου κωδικου.
          </div>

          <div className={'change-password-form-container mt-3'}>
            <Form
              form={form}
              onFinish={handleSubmit}
              layout="vertical"
              className={'change-password-form'}
            >
              <Form.Item
                label="Email"
                name="email"
                className={'change-password-form-item'}
              >
                <Input
                  placeholder="Εισάγετε Email"
                  value={email} // Bind input value to email state
                  onChange={e => setEmail(e.target.value)} // Update email state on change
                  disabled={loading}
                  className={'change-password-input'}
                />
              </Form.Item>
              <div
                id="go-back-from-change-password"
                className="go-back-from-change-password mt-3"
              >
                <Link to="/login" className={'change-password-back-link'}>
                  <ArrowLeft />
                  <span>Πίσω στην είσοδο</span>
                </Link>
              </div>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                className={'change-password-submit-btn mt-1'}
                disabled={isEmpty(email) || loading}
              >
                Υποβολή
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
